<template>

    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table :headers="headers" :items="document_type_list" dense class="elevation-1 mytable"
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Instructor Document Type</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="2" cols="12"> </v-col>
                        <v-col sm="6" md="5" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px"> </span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="primary mb-2 button" v-on="on" small>
                                    Add Instructor Document Type
                                </v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>

                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.document_type" color="primary"
                                                        label="Enter Document Type" variant="underlined"
                                                        outlined></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>

                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>

                        <v-btn text icon color=" lighten-1" @click="deleteType(item)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>

            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            applicationStatus: false,
        },

        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        document_type_list: [],

        headers: [
            {
                text: "Document Type",
                align: "left",
                sortable: false,
                value: "document_type",
            },
            {
                text: "Active",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
        ],

        editedIndex: -1,
        editedItem: {
            id: "",
            document_type: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            document_type: "",
            isactive: true,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? "New Document Type"
                : "Edit Document Type";
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.overlay = true;
            axios
                .post("/AdmissionMaster/getInstructorDocumentTypes")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.document_type_list = res.data.document_type_list;
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })

        },

        editItem(item) {
            this.editedIndex = this.document_type_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/editInstructorDocumentType", this.editedItem)
                        .then((res) => {
                            if (res.data.code == "SUCCESS") {
                                this.showSnackbar("#4caf50", "Document Type Updated Successfully...");
                                this.onLoad();
                            } else if (res.data.code === "NA") {
                                this.showSnackbar("#b71c1c", res.data.msg);
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/saveInstructorDocumentType", this.editedItem)
                        .then((res) => {
                            if (res.data.code == "SUCCESS") {
                                this.showSnackbar("#4caf50", "Document Type Added Successfully!!!");
                                this.onLoad();
                            } else if (res.data.code == "NA") {
                                this.showSnackbar("#b71c1c", "Document Type Already Present!!!");
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            }
        },

        deleteType(item) {
            if (confirm("Are you sure want to delete the document type?")) {
                const payload = {
                    id: item.id
                }
                axios.post("AdmissionMaster/deleteInstructorDocumentType", payload)
                    .then((res) => {
                        if (res.data.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "Document Type Deleted Successfully!!!")
                            this.onLoad();
                        } else if (res.data.code === "NA") {
                            this.showSnackbar("#b71c1c", "Document Type Not Found!!!")
                        } else {
                            this.showSnackbar("#b71c1c", "Something Went Wrong!!!")
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
        },

        isValidated() {
            if (this.editedItem.document_type) {
                return true;
            }
            else {
                if (!this.editedItem.document_type) {
                    this.showSnackbar("#b71c1c", "Enter document type name!!!");
                }

                return false;
            }
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
